import { FC } from 'react';
import {
  TextBody,
  Spacer,
  Stack,
  BlockList,
  Select,
  SelectOption,
  Icon,
  Tooltip,
} from '@pypestream/design-system';
import { useFormContext } from 'react-hook-form';
import { useProStudioCtxSelector } from '../../../xstate/app.xstate';
import { ProStudioContext } from '../../../xstate/prostudio.xstate.types';

export const TabConfig: FC<{ viewOnly?: boolean }> = ({ viewOnly }) => {
  const { register } = useFormContext();

  const { credentials, draftVersionSolutionData } = useProStudioCtxSelector(
    (ctx: ProStudioContext) => ({
      credentials: ctx.credentials,
      draftVersionSolutionData: ctx.draftVersionSolutionData,
    })
  );

  const getModelIcon = (providerName?: string) => {
    const provider = providerName?.toLowerCase();
    switch (provider) {
      case 'openai':
        return 'gpt';
      case 'anthropic':
        return 'claude';
      case 'google':
        return 'gemini';
      default:
        return 'gemini';
    }
  };

  return (
    <>
      <BlockList>
        <div>
          <Stack alignItems="center" gutter="2xsmall">
            <TextBody size="small">Model</TextBody>
            <Tooltip
              placement="right"
              content="Choose the large language model (LLM) to power your supervisor, such as ChatGPT, Gemini, or Claude."
            >
              <Icon name="info" color="gray" size="xsmall" />
            </Tooltip>
          </Stack>
          <Spacer size="2xsmall" />
          <Select
            test-id="ps-agents-config-model-select"
            variant="outlined"
            placeholder="Select a model"
            defaultValue={draftVersionSolutionData?.llmCredential?.id}
            {...register('llmCredentialId')}
            disabled={viewOnly}
          >
            {credentials?.map((credential) => (
              <SelectOption key={credential.id} value={credential.id || ''}>
                <Icon
                  name={getModelIcon(credential.llmProvider?.name)}
                  size="small"
                  slot="prefix"
                />
                {`${credential.name} (${credential.llmProvider?.name || 'Gemini'})`}
              </SelectOption>
            ))}
          </Select>
        </div>
      </BlockList>
    </>
  );
};
